import { $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewport } from '../getViewport';

export const storyGallery = () => {
  const galleries = $$('.story-gallery__inner');

  if (galleries.length) {
    galleries.forEach(gallery => {
      const items = $$('.story-gallery__item', gallery);

      items.forEach(item => {
        gsap.set(item, {
          opacity: viewport.isReduced ? 1 : 0,
          y: 50,
        });

        const timeline = gsap.timeline();

        timeline.to(item, {
          opacity: 1,
          y: 0,
        });

        ScrollTrigger.create({
          animation: timeline,
          trigger: item,
          start: () => (viewport.isMobile ? 'top 90%' : 'top 80%'),
          end: () => 'bottom center',
          toggleActions: 'play pause resume reverse',
        });
      });
    });
  }
};
